<template>
  <div class="question-option__radio-section">
    <data :id="optionName"></data>
      <div class="question-option__radio-container" :id="optionName + '-container'">
          <label :for="optionName" class="question-option__radio-container-label">
              <div class="question-option__radio-label">
                  <div class="question-option__label-left">
                      <span class="question-option__label-text">{{ labelText }}</span>
                      <div v-if="modalTitle !== null && modalText !== null" class="question-option__label-info" @click.stop="setModal()">i</div>
                  </div>
                  <div class="question-option__label-right question-option__radio-btns">
                      <div class="redesign-radio question-option__radio">
                          <input
                            class="redesign-radio__input"
                            type="radio"
                            :id="optionName + '-yes'"
                            v-model="optionValue"
                            :name="optionName"
                            :value="true"
                            autocomplete="off"
                            data-validate="radio"
                            :data-validate-message="validateMessage"
                            :data-error-target="optionName"
                          />
                          <label class="redesign-radio__label" :for="optionName + '-yes'">
                              <span class="redesign-radio__span"></span>Yes
                          </label>
                      </div>

                      <div class="redesign-radio question-option__radio">
                          <input
                              class="redesign-radio__input"
                              type="radio"
                              :id="optionName + '-no'"
                              v-model="optionValue"
                              :name="optionName"
                              :value="false"
                              autocomplete="off"
                          />
                          <label class="redesign-radio__label" :for="optionName + '-no'">
                              <span class="redesign-radio__span"></span>No</label>
                      </div>
                  </div>
              </div>
          </label>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
      labelText: {
        type: String,
        default: null,
        required: true,
      },
      modalText: {
        type: String,
        default: null,
        required: false,
      },
      modalTitle: {
        type: String,
        required: false,
      },
      optionName: {
        type: String,
        required: true,
      },
      validateMessage: {
        type: String,
        default: "Please make a selection"
      },
      healthCheckOptions:{
        type: Boolean,
        required: false,
      },

  },
  computed: {
    ...mapGetters('ValuationExtended', ['getOption', 'getVehicleHealthCheckOptions']),
    optionValue: {
    get() {
      if (this.healthCheckOptions) {
        const value = this.getVehicleHealthCheckOptions(this.optionName);
        return !value;
      } else {
        return this.getOption(this.optionName);
      }
    },
    set(newValue) {
      if (this.healthCheckOptions) {
          this.setVehicleHealthCheckCondition({ optionName: this.optionName, value: !newValue });
      } else {
        this.setMechanicalCondition({ optionName: this.optionName, value: newValue });
      }
    }
  }
  },

  methods: {
    ...mapActions("ValuationExtended", ["setMechanicalCondition", "setVehicleHealthCheckCondition"]),

    setModal() {
      let modalData = {
          text: this.modalText,
          title: this.modalTitle,
      };
      this.$emit('set-modal', modalData);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/QuestionOption.vue